export default __webpack_public_path__ + "static/media/noArtists.ab3c20bf.svg";